import React, { MutableRefObject } from 'react';
import { rem } from 'polished';
import { colors, mixins } from '../../core/styles/theme/default';
import styled from '@emotion/styled';

const StyledCookieOption = styled.div`
  margin-top: ${rem(28)};
  position: relative;

  input {
    &:checked + label::before {
      background: ${colors.nightBlue900}
        url("data:image/svg+xml,%3Csvg width='12' height='11' viewBox='0 0 12 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.6667 1L4.66671 9L1.33337 6' stroke='white' stroke-width='1.5'/%3E%3C/svg%3E")
        no-repeat center / ${rem(12)} ${rem(11)};
    }

    &:disabled + label {
      cursor: not-allowed;

      &::before {
        opacity: 0.5;
      }
    }
  }

  label {
    display: block;
    cursor: pointer;
    position: relative;
    color: ${colors.nightBlue900};
    font-size: ${rem(16)};
    line-height: ${rem(26)};
    padding-left: ${rem(30)};

    ${mixins.MQ('medium')} {
      font-size: ${rem(18)};
      line-height: ${rem(28)};
    }

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: ${rem(3)};
      left: 0;
      width: ${rem(20)};
      height: ${rem(20)};
      border: ${rem(1)} solid ${colors.nightBlue900};
      border-radius: ${rem(4)};
    }

    span {
      font-weight: 500;
      display: block;
    }
  }

  ${({ theme }) => theme?.stylesExtension?.cookieBanner?.cookieOption}
`;

const CookieOption = ({
  name,
  refItem,
  checked,
  children,
  ...props
}: CookieOptionProps) => {
  return (
    <StyledCookieOption>
      <input
        type="checkbox"
        className="sr-only"
        id={name}
        ref={refItem}
        defaultChecked={checked}
        {...props}
      />
      <label htmlFor={name}>{children}</label>
    </StyledCookieOption>
  );
};

type CookieOptionProps = {
  name: string;
  refItem?: MutableRefObject<HTMLInputElement>;
  checked?: boolean;
  disabled?: boolean;
  children: any;
};

export default CookieOption;
